/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MetricValueAggregatedResponseDto } from './MetricValueAggregatedResponseDto';
import {
    MetricValueAggregatedResponseDtoFromJSON,
    MetricValueAggregatedResponseDtoFromJSONTyped,
    MetricValueAggregatedResponseDtoToJSON,
    MetricValueAggregatedResponseDtoToJSONTyped,
} from './MetricValueAggregatedResponseDto';

/**
 * 
 * @export
 * @interface MetricValuesAggregationResponseDto
 */
export interface MetricValuesAggregationResponseDto {
    /**
     * List of aggregated metric values by interval
     * @type {Array<MetricValueAggregatedResponseDto>}
     * @memberof MetricValuesAggregationResponseDto
     */
    data: Array<MetricValueAggregatedResponseDto>;
    /**
     * Total number of intervals
     * @type {number}
     * @memberof MetricValuesAggregationResponseDto
     */
    totalIntervals: number;
}

/**
 * Check if a given object implements the MetricValuesAggregationResponseDto interface.
 */
export function instanceOfMetricValuesAggregationResponseDto(value: object): value is MetricValuesAggregationResponseDto {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('totalIntervals' in value) || value['totalIntervals'] === undefined) return false;
    return true;
}

export function MetricValuesAggregationResponseDtoFromJSON(json: any): MetricValuesAggregationResponseDto {
    return MetricValuesAggregationResponseDtoFromJSONTyped(json, false);
}

export function MetricValuesAggregationResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MetricValuesAggregationResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(MetricValueAggregatedResponseDtoFromJSON)),
        'totalIntervals': json['totalIntervals'],
    };
}

export function MetricValuesAggregationResponseDtoToJSON(json: any): MetricValuesAggregationResponseDto {
    return MetricValuesAggregationResponseDtoToJSONTyped(json, false);
}

export function MetricValuesAggregationResponseDtoToJSONTyped(value?: MetricValuesAggregationResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(MetricValueAggregatedResponseDtoToJSON)),
        'totalIntervals': value['totalIntervals'],
    };
}

